import '@/styles/object/project/_questionnaire.scss';

$(document).on('click', '.file-select', function () {
  const questionnaireFieldId = $(this).data('questionnaire-field-id');
  const index = $(this).data('index');
  $(`#attachments_${questionnaireFieldId}_${index}`).trigger('click');
  $(this).parents('.c-form--file').find('.filename').val('');
});

$(document).on('change', 'input[type=file]', function () {
  const filename = $(this).parents('.c-form--file').find('.filename');
  filename.val($(this).prop('files')[0].name);
});

$(document).on('click', '.add-image', function () {
  const questionnaireFieldId = $(this).data('questionnaire-field-id');
  const maxCount = $(this).data('max-count');
  const rootArea = $(`#questionnaire_field_${questionnaireFieldId}`);
  const index = rootArea.find('.file-select').last().data('index') + 1;
  if (index >= maxCount) {
    return false;
  }
  rootArea.append(`
    <div class="c-form--file">
      <input type="text" name="filename" id="filename" class="filename" readonly="readonly" placeholder="select file..." style="height: 46px; margin-top: 8px; margin-bottom: 8px;">
      <input type="file" name="user_questionnaire_form[user_extend_questionnaire_fields][${questionnaireFieldId}][attachments][]" id="attachments_${questionnaireFieldId}_${index}", accept=".jpg, .jpeg, .gif, .png", style="display: none;">
      <input type="hidden" name="user_questionnaire_form[user_extend_questionnaire_fields][${questionnaireFieldId}][attachments_cache][]" id="attachments_${questionnaireFieldId}_${index}_cache">
      <button name="button" type="button" class="file-select" data-questionnaire-field-id="${questionnaireFieldId}" data-index="${index}" style="height: 46px; margin-top: 8px; margin-bottom: 8px;">ファイル選択</button>
    </div>
  `);
  if (index + 1 >= maxCount) {
    $(this).hide();
  }
});

$(document).on('keypress', '.js-prevent-enter-submit', function (e) {
  if ((e as JQuery.KeyPressEvent).key === 'Enter') {
    e.preventDefault();
  }
});

$(document).on('click', '#answer_submit', function () {
  if (!$('.multi-select-group').length) {
    return;
  }
  $('.multi-select-group').each(function (_index, element) {
    if ($(element).data('required')) {
      validateMultiSelect($(element).data('group'));
    }
  });
});

function validateMultiSelect(groupId: string) {
  const checkedsum = $(`.multi-select-group-${groupId}:checked`).length;
  const element = $(`.multi-select-group-${groupId}`)[0] as HTMLInputElement;
  if (checkedsum === 0) {
    element.setCustomValidity('いずれかを選択してください');
  } else {
    element.setCustomValidity('');
  }
}
